import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// @material-ui/icons

// core components
import Header from "components/Header/Header.js";
import Footer from "components/Footer/Footer.js";
import HeaderLinks from "components/Header/HeaderLinks.js";

import styles from "assets/jss/material-kit-react/views/staticPages.js";
import Parallax from "components/Parallax/Parallax";

const dashboardRoutes = [];

const useStyles = makeStyles(styles);

export default function DeveloperPage(props) {
  const classes = useStyles();
  const { ...rest } = props;
  return (
    <div>
      <Header
        color="transparent"
        routes={dashboardRoutes}
        rightLinks={<HeaderLinks />}
        fixed
        changeColorOnScroll={{
          height: 400,
          color: "white"
        }}
        {...rest}
      />
      <Parallax small filter image={require("assets/img/header-back.jpg")} />
      <div className={classNames(classes.main, classes.mainRaised)}>
 
        <div className={classes.container}>
            <br/>
            <h2 className={classes.title}>Desenvolvido por Ambulancia App</h2>
            <p className={classes.description}>Esse aplicativo foi criado pela:</p>
            <p className={classes.description}>
            New App
            </p>
            <p className={classes.description}>
            Para solicitar um orçamento entre em contato
            </p>
            <p className={classes.description}>
            (11) 97552-8932
            </p>
            <p className={classes.description}>
            Newapp.contato@gmail.com
            </p>
            <br/>
        </div>
        </div>

      <Footer />
    </div>
  );
}
